import React, {useMemo} from 'react';
import {Flex, Heading} from '@spothero/ui';
import PropTypes from 'prop-types';

const ParkingInstructions = ({instructions, showHeading, subHeading}) => {
    const formattedInstructions = useMemo(() => {
        if (!instructions) {
            return [];
        }

        return instructions.map((item, i) => {
            const formattedItem = item.text.replace(/\r?\n/g, '<br>');

            return (
                <Flex
                    key={item.id}
                    borderRadius="md"
                    borderWidth="1px"
                    borderColor="gray.100"
                    padding={3}
                    marginBottom={4}
                >
                    <Flex
                        fontWeight="semibold"
                        color="white"
                        backgroundColor="primary.default"
                        width={7}
                        height={7}
                        borderRadius="50%"
                        alignSelf="start"
                        alignItems="center"
                        justifyContent="center"
                        fontSize="base"
                    >
                        {i + 1}
                    </Flex>
                    <Flex
                        flex="1"
                        flexDirection="column"
                        marginLeft={4}
                        dangerouslySetInnerHTML={{__html: formattedItem}}
                        fontSize="base"
                    />
                </Flex>
            );
        });
    }, [instructions]);

    if (!instructions?.length) {
        return null;
    }

    return (
        <>
            {showHeading && (
                <Heading id="parking-instructions" as="h2" marginBottom={3}>
                    Parking Instructions
                </Heading>
            )}
            {subHeading && (
                <Heading
                    id="parking-instructions"
                    as="h3"
                    marginBottom={4}
                    marginTop={4}
                >
                    {subHeading}
                </Heading>
            )}
            {formattedInstructions}
        </>
    );
};

ParkingInstructions.propTypes = {
    instructions: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            text: PropTypes.string.isRequired,
        }).isRequired
    ),
    subHeading: PropTypes.string,
    showHeading: PropTypes.bool,
};

ParkingInstructions.defaultProps = {
    subHeading: '',
    showHeading: true,
};

export default ParkingInstructions;
